/**
 * Compute target year based on March 31 cutoff.
 * Through March 31 (inclusive) → previous year; April 1 onward → current year.
 */
export const getTargetYearForDefaults = (today = new Date()): number => {
  const isAfterCutoff = today.getMonth() > 2;
  return isAfterCutoff ? today.getFullYear() : today.getFullYear() - 1;
};

/** Get default period range {start, end} based on March 31 cutoff. */
export const getDefaultPeriodRange = (
  today = new Date()
): { start: string; end: string } => {
  const targetYear = getTargetYearForDefaults(today);
  return {
    start: `${targetYear}-01-01`,
    end: `${targetYear}-12-31`,
  };
};

/**
 * Date utility functions for cancellation components
 */
export const useDateUtils = () => {
  /**
   * Convert datetime string to date string for HTML date inputs
   */
  const convertDateTimeToDate = (dateTimeString: string): string => {
    if (!dateTimeString) return "";

    try {
      const date = new Date(dateTimeString);
      if (isNaN(date.getTime())) return "";

      // Format as YYYY-MM-DD for HTML date input
      return date.toISOString().split("T")[0];
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      return "";
    }
  };

  return {
    getDefaultPeriodRange,
    convertDateTimeToDate,
  };
};
